module.exports = __webpack_public_path__ + "media/T-Classic-Ft-Mayorkun-Fall-In-Love-Prod-By-Killertunes-1.3aeb02cf.mp3";